import { Trans, useTranslation } from 'react-i18next'

import { Alert, Link, Switch, Text } from '@reveni-io/reveni-ui'

import { preferences } from '@/configuration/pages/ConfigurationPage/constants'
import routes from '@/Router/routes.constants'

import * as Styles from './styles'

const OrderIdentification = ({
  allowedPreferences,
  allowsOrderRecovery,
  hasOrderRecoveryEmailTemplate,
  onChangeAllowsOrderRecovery,
}) => {
  const { t } = useTranslation()

  const shouldWarnAboutMissingTemplate = allowsOrderRecovery && !hasOrderRecoveryEmailTemplate

  const handleChange = e => onChangeAllowsOrderRecovery(e.target.checked)

  if (!allowedPreferences.includes(preferences.allowsOrderRecovery)) return null

  return (
    <Styles.Container>
      <Text type="titleS">{t('Identificación de pedido')}</Text>
      <Text type="bodyMRegular">
        {t(
          'No todos los clientes recuerdan su número de pedido al iniciar una devolución. Activa esta opción para que puedan buscarlo con su email.'
        )}
      </Text>
      <Switch
        label={<Text type="bodyMBold">{t('Permitir que los clientes busquen su pedido por email')}</Text>}
        checked={allowsOrderRecovery}
        onChange={handleChange}
      />
      {shouldWarnAboutMissingTemplate && (
        <Alert type="info">
          <Trans
            i18nKey="orderRecoveryTemplateMissing"
            components={{ templatesLink: <Link href={routes.configurationPage.emailTemplates} /> }}
          >
            Para asegurarte de que los clientes reciben el email de recuperación, configura una plantilla activa en{' '}
            <Link href={routes.configurationPage.emailTemplates}>Comunicaciones &gt; Plantillas</Link> con el trigger
            &quot;Order recovery link requested&quot;.
          </Trans>
        </Alert>
      )}
    </Styles.Container>
  )
}

export default OrderIdentification
